/**
 * @file: index.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export const deg2rad_factor = Math.PI / 180.0;

export const deg2rad = (x: number) => x * deg2rad_factor;
export const rad2deg = (x: number) => x / deg2rad_factor;
